import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'firebird-web-no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoPermissionComponent {
  constructor(private readonly authService: AuthService) {}

  public logout(): void {
    this.authService.logout();
  }
}
